// src/components/store/sections/weekly-banner/WeeklyBannerV74MagazineissueCoralFlame.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV74MagazineissueCoralFlame(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={74}
      archKey="magazine_issue"
      archLabel="Editorial Issue Banner"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      {...props}
    />
  );
}
